import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import axios from 'axios';
import { getApiUrl } from '../utils/apiUrl';
import './Contact.css';

const Contact = ({ settings }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    // Clear error when user starts typing
    if (error) setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await axios.post(`${getApiUrl()}/contact`, formData);
      
      if (response.data.message) {
        setSubmitted(true);
        // Reset form
        setFormData({
          name: '',
          email: '',
          message: ''
        });
        // Hide success message after 5 seconds
        setTimeout(() => setSubmitted(false), 5000);
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to send message. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Contact Us - NieHairLabel</title>
        <meta name="description" content="Get in touch with NieHairLabel" />
      </Helmet>
      <div className="contact-page">
        <div className="container">
          <h1>Contact Us</h1>
          <div className="contact-content">
            <div className="contact-info">
              <h2>Get in Touch</h2>
              {settings?.contact_email && (
                <div className="contact-item">
                  <strong>Email:</strong>
                  <a href={`mailto:${settings.contact_email}`}>{settings.contact_email}</a>
                </div>
              )}
              {settings?.contact_phone && (
                <div className="contact-item">
                  <strong>Phone:</strong>
                  <a href={`tel:${settings.contact_phone}`}>{settings.contact_phone}</a>
                </div>
              )}
              {settings?.contact_address && (
                <div className="contact-item">
                  <strong>Address:</strong>
                  <p>{settings.contact_address}</p>
                </div>
              )}
            </div>

            <form onSubmit={handleSubmit} className="contact-form">
              <h2>Send us a Message</h2>
              {submitted && (
                <div className="success-message">
                  Thank you for your message! We'll get back to you soon.
                </div>
              )}
              {error && (
                <div className="error-message" style={{ 
                  background: '#fee', 
                  color: '#c33', 
                  padding: '1rem', 
                  borderRadius: '4px', 
                  marginBottom: '1.5rem',
                  border: '1px solid #fcc'
                }}>
                  {error}
                </div>
              )}
              <div className="form-group">
                <label>Name *</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label>Email *</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label>Message *</label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows="6"
                  required
                />
              </div>
              <button type="submit" className="btn btn-primary" disabled={loading}>
                {loading ? 'Sending...' : 'Send Message'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;



